import * as retirementConstants from '../RetirementWorkflow/RetirementWorkflowConstants';
import * as educationConstants from '../EducationWorkflow/EducationWorkflowConstants';
import * as debtManagementConstants from '../DebtManagementWorkflow/DebtManagementWorkflowConstants';
import * as homePurchaseConstants from '../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import * as largePurchaseConstants from '../LargePurchaseWorkflow/LargePurchaseWorkflowConstants';
import * as emergencyFundConstants from '../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import * as financialAccountsWorkflowConstants from '../FinancialAccountsWorkflow/FinancialAccountsWorkflowConstants';
import * as healthcareWorkflowConstants from '../HealthcareWorkflow/HealthcareWorkflowConstants';
import * as decumulationWorkflowConstants from '../DecumulationWorkflow/DecumulationWorkflow.constants';
import { isEmpty } from '../../../js/app/react/validators';

const analyticsEventNameSpace = {
  [retirementConstants.WORKFLOW_ID]: [retirementConstants.ANALYTICS_ID],
  [educationConstants.WORKFLOW_ID]: [educationConstants.ANALYTICS_ID],
  [debtManagementConstants.WORKFLOW_ID]: [debtManagementConstants.ANALYTICS_ID],
  [homePurchaseConstants.WORKFLOW_ID]: [homePurchaseConstants.ANALYTICS_ID],
  [largePurchaseConstants.WORKFLOW_ID]: [largePurchaseConstants.ANALYTICS_ID],
  [emergencyFundConstants.WORKFLOW_ID]: [emergencyFundConstants.ANALYTICS_ID],
  [financialAccountsWorkflowConstants.WORKFLOW_ID]: [
    financialAccountsWorkflowConstants.ANALYTICS_ID,
  ],
  [healthcareWorkflowConstants.WORKFLOW_ID]: [healthcareWorkflowConstants.ANALYTICS_ID],
  [decumulationWorkflowConstants.WORKFLOW_ID]: [decumulationWorkflowConstants.ANALYTICS_ID],
};

export const getAnalyticsNameSpace = workflowId => analyticsEventNameSpace[workflowId];

const logWorkflowEvent = workflowId => {
  const nameSpace = getAnalyticsNameSpace(workflowId);
  if (isEmpty(nameSpace)) {
    throw new Error(`analyticsID is missing for workflowID: '${workflowId}'.`);
  }
};

export default logWorkflowEvent;
